import * as React from 'react';
import { EPdfMode } from '../pdf/Pdf';

/**
 * @description applies a color to the legend text
 * @param value
 * @param printMode
 * @returns
 */
export const legendFormatter = (
  value: string,
  printMode: EPdfMode = EPdfMode.DEFAULT
): React.ReactElement => {
  return (
    <span
      style={{
        color:
          printMode === EPdfMode.PRINT
            ? 'var(--color-text)'
            : 'rgba(255,255,255,0.72)',
      }}
    >
      {value}
    </span>
  );
};
